// removed by extract-text-webpack-plugin
module.exports = {"curtain":"DeathCurtainComponent__curtain___3urAX","msg":"DeathCurtainComponent__msg___2ri3O","visible":"DeathCurtainComponent__visible___3PEOE","tryAgain":"DeathCurtainComponent__tryAgain___3io6u","closed":"DeathCurtainComponent__closed___3rcmb"};


//////////////////
// WEBPACK FOOTER
// ./src/game/menus/DeathCurtainComponent.scss
// module id = 154
// module chunks = 0